import {Box, memoWithType, useDebounce} from "@hosttools/frontend";
import {type Column, type Table} from "@tanstack/react-table";
import {useCallback, useState} from "react";

import SearchInput from "../SearchInput";

interface BaseProps {
    placeholder?: string;
    className?: string;
}

interface PropsColumn<T> extends BaseProps {
    kind: "column";
    table: Table<T>;
    column: Column<T, unknown>;
}

interface PropsTable<T> extends BaseProps {
    kind: "table";
    table: Table<T>;
}

type Props<T> = StrictUnion<PropsTable<T> | PropsColumn<T>>;

const FilterText = <T,>({placeholder, kind, column, table, className}: Props<T>) => {
    const [searchText, setSearchText] = useState("");

    useDebounce(searchText, 350, value => {
        // probably reset the paging for every new search
        table.setPageIndex(0);
        if (kind === "table") {
            table.setGlobalFilter(value);
        } else {
            column.setFilterValue(value);
        }
    });

    const handleClearSearch = useCallback(() => {
        setSearchText("");
    }, []);

    return (
        <Box className={className}>
            <SearchInput
                placeholder={placeholder}
                query={searchText}
                testID="table-input-search"
                onChangeText={setSearchText}
                onClear={handleClearSearch}
            />
        </Box>
    );
};

export default memoWithType(FilterText);
